var FeatureSlider = {}, $featureSlider;

FeatureSlider = {
  init() {
    $featureSlider = $('.js-feature-slider');

    if ($featureSlider.length === 0) {
      return;
    }

    $.each( $featureSlider, function() {
      let $slider = $(this),
        $autoplay = $slider.data('autoplay');

      $slider.flickity({
        autoPlay: $autoplay,
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: true,
				dragThreshold: 10,
				wrapAround: true,
			});
    });
  },
}

$(function () {
  FeatureSlider.init();

  $(window).resize(function () {
    FeatureSlider.init();
  });
});

window.FeatureSlider = FeatureSlider;



// WEBPACK FOOTER //
// ./scripts/components/sliders/feature-slider.js